import React, { Component } from 'react';
import Backend from '../../api/Backend';
import RampButton from '../RampButton/RampButton';

import RampIcon from '../RampIcon/RampIcon';
import RampThemes from '../Themes/RampThemes';

import './Main_Images.css';
import './Main.css';


class Main extends Component {
	state = {
		loading: false,
		currentScene: 'front',
		currentRamp: 'ramp1'
	}

	async componentWillUnmount() {
		Backend.close();
	}

	handleAnimationEnd = () => {
		this.setState((state) => ({ loading: false }));
	}

	waitOn = (callbackFunction) => {
		this.setState((state) => ({ loading: true }));

		// TODO: Uncomment this
		callbackFunction();

        /*
        setTimeout(() => {
            this.setState((state) => ({loading: false}));
        }, 1568);
        */

		if (RampThemes.GetLiteMode()) {
			this.handleAnimationEnd();
		}
	}

	handleRamp1Click = () => {
		this.setState((state) => ({ currentScene: 'front', currentRamp: 'ramp1' }));
		this.waitOn(Backend.raiseRamp1);
	}

	handleRamp2Click = () => {
		this.setState((state) => ({ currentScene: 'back', currentRamp: 'ramp2' }));
		this.waitOn(Backend.raiseRamp2);
	}

	handleRamp3Click = () => {
		this.setState((state) => ({ currentScene: 'back', currentRamp: 'ramp3' }));
		this.waitOn(Backend.raiseRamp3);
	}

	switchMode = () => {
		let isDarkMode = !this.getDarkMode();
		this.setDarkMode(isDarkMode);
	}

	render() {
		const animateRamp1 = this.state.currentRamp === 'ramp1' && this.state.loading ? "true" : "";
		const animateRamp2 = this.state.currentRamp === 'ramp2' && this.state.loading;
		const animateRamp3 = this.state.currentRamp === 'ramp3' && this.state.loading;

		let isLiteMode = RampThemes.GetLiteMode();
		let headerElement = null;
		let mainContentClassName = "main__content main__content_lite";
		
		if (!isLiteMode)
		{
			const scene = 'main__header main__header--background-' + this.state.currentScene;
			RampThemes.ApplyColorScheme();
			mainContentClassName = "main__content";

			headerElement = <header className={scene}>
						<span className="main__title">Dizalica</span>
						<RampIcon ramp='ramp1' visible={this.state.currentScene === 'front'} onAnimationEnd={this.handleAnimationEnd} animate={animateRamp1} />
						<RampIcon ramp='ramp2' visible={this.state.currentScene === 'back'} onAnimationEnd={this.handleAnimationEnd} animate={animateRamp2} />
						<RampIcon ramp='ramp3' visible={this.state.currentScene === 'back'} onAnimationEnd={this.handleAnimationEnd} animate={animateRamp3} />
			</header>;
		}

		return (

			<section className="main">
				{ headerElement }

				<section className={mainContentClassName}>
					<RampButton onClick={this.handleRamp1Click} className="main__button" loading={animateRamp1} disabled={this.state.loading}>
						GLAVNI ULAZ
                    </RampButton>
					{/*
                    <RampButton onClick={this.handleRamp2Click} className="main__button" loading={animateRamp2} disabled={loading}> 
                        DELLBOY'S
                    </RampButton>
                    <RampButton onClick={this.handleRamp3Click} className="main__button" loading={animateRamp3} disabled={loading}> 
                        KONZUM
                    </RampButton>
                    */}
				</section>
			</section>
		);
	}
}

export default Main;
